<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="toc"><span class="epub-sc">CONTENTS</span></p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/ded#ded">Dedication</a></p>
<p class="toc-bot"><a href="#/xhtml/characters#char">Characters</a></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">Act One</a></p>
<p class="toc-bot"><span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample">Act Two</span></p>
<p class="toc"><span href="#/xhtml/adcard#ad" title="Link target outside of Sample">Also by Derek Walcott</span></p>
<p class="toc"><span href="#/xhtml/copyright#crp" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?22865213